<template>
  <div>

    <el-row :gutter="20">
      <el-col :span="col1">
        <el-form :inline="true">
          <el-form-item>
            <el-input v-model="queryUserDesc" size="small" placeholder="请输入查询条件" class="sx-input"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="tableData" border highlight-current-row @row-click="handleCurrentRowChange">
          <el-table-column label="用户列表">
            <el-table-column prop="id" label="编号" v-if="isShow">
            </el-table-column>
            <el-table-column sortable prop="userName" label="用户名" show-overflow-tooltip header-align="center" align="center">
            </el-table-column>
            <el-table-column sortable prop="userDesc" label="姓名" show-overflow-tooltip>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-pagination small layout="total,prev, pager, next" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-size="pageSize" :total="totalRows">
        </el-pagination>
      </el-col>
      <el-col :span="col2">
        <el-form :inline="true">
          <el-form-item>
            <el-button type="primary" size="small" plain @click="handleAddDept">添加部门</el-button>
          </el-form-item>
        </el-form>

        <el-table v-loading="loading" :data="tableDataDept" border highlight-current-row>
          <el-table-column label="已选列表">
            <el-table-column prop="id" label="编号" width="60" v-if="isShow">
            </el-table-column>
            <el-table-column sortable prop="dept.deptCode" label="部门编码" width="120" show-overflow-tooltip header-align="center"
              align="center">
            </el-table-column>
            <el-table-column sortable prop="dept.deptName" label="部门名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="100px" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="handleDeleteDept(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>


      <el-col :span="col3">
        <el-form :inline="true">
          <el-form-item>
            <el-button type="primary" size="small" plain @click="handleAddPost">添加岗位</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="tableDataPost" border highlight-current-row>
          <el-table-column label="已选列表">
            <el-table-column prop="id" label="编号" width="60" v-if="isShow">
            </el-table-column>
            <el-table-column sortable prop="post.postCode" label="岗位编码" width="120" show-overflow-tooltip header-align="center"
              align="center">
            </el-table-column>
            <el-table-column sortable prop="post.postName" label="岗位名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="100px" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="handleDeletePost(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog :close-on-click-modal="false"   v-dialogDrag title="添加信息" :visible.sync="dialogVisible" width="800px">
      <el-row>
        <el-col :span="10">
          <div class="tree-container" style="width: 300px; padding-right: 50px;">
            <el-tree v-loading="loadingTree" :data="dataTree" :props="defaultProps" node-key="id" :expand-on-click-node="false"
              @check-change="handleNodeClick" show-checkbox default-expand-all>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="dialog-table-container" style="padding-left: 150px;width: 271px;">
            <el-table :data="DialogTableData" border highlight-current-row @row-click="handleDialogChange">
              <el-table-column prop="id" label="编号" width="60" v-if="isShow">
              </el-table-column>
              <el-table-column prop="postName" label="岗位名称" width="120" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="postDesc" label="岗位说明" width="150" show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
      <el-button type="success" @click="handleSave" style="width: 200px;">保存</el-button>
      <el-button @click="handleCancelSave" style="width: 200px;margin-left: 330px;">取消</el-button>
    </el-dialog>

    <Popup v-on:receviceFromChild="receviceFromPost" ref="popupPost" :tableProperty="popupTableProperty" :url="url"
      width="600px" height="500px"></Popup>
    <popup-dept-tree v-on:receviceFromChild="receviceFromDept" ref="popupDept"></popup-dept-tree>

  </div>
</template>

<script>
  import axios from '@/axios'
  import Popup from '@/components/system/Popup.vue'
  import PopupDeptTree from '@/components/system/PopupDeptTree.vue'
  export default {
    components: {
      Popup,
      PopupDeptTree
    },
    data() {
      return {
        col1: 6,
        col2: 9,
        col3: 9,
        dataTree: [],
        defaultProps: {
          children: 'children',
          label: 'text'
        },
        fid: '',
        //表格初始化参数
        tableData: [],
        tableDataDept: [],
        tableDataPost: [],
        YesTableData: [],
        DialogTableData: [],
        currentPage: 1,
        totalRows: 0,
        pageSize: 15,
        pageSizes: [10, 20, 30, 40],
        dialogVisible: false,
        queryUserDesc: '',
        isShow: false,
        loading: true,
        loadingTree: true,
        udp: {
          "dept": {
            "deptName": "",
            "id": ""
          },
          "id": "",
          "post": {
            "id": "",
            "postName": ""
          },
          "user": {
            "id": "",
            "userDesc": "",
          }
        },

        userDept: {
          id: '',
          user: {
            id: ''
          },
          dept: {
            id: ''
          }
        },
        userPost: {
          id: '',
          user: {
            id: ''
          },
          post: {
            id: ''
          }
        },
        url: 'system/SysPost/queryByPostName.do',
        popupTableProperty: [{
            "id": "1",
            "tableProp": "id",
            "tableLabel": "id",
            "tableWidth": "100",
            isShow: '1'
          },
          {
            "id": "2",
            "tableProp": "postCode",
            "tableLabel": "岗位编码",
            "tableWidth": "150",
            isShow: '0'
          }, {
            "id": "3",
            "tableProp": "postName",
            "tableLabel": "岗位名称",
            "tableWidth": "250",
            isShow: '0'
          }
        ],
      }
    },
    //界面渲染完毕调用   初始化表格参数
    mounted() {
      this.getTableData()
      // 			this.getYesTableData()
    },
    methods: {
      // 获取table数据
      getTableData() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysUser/query.do'
        var param = {
          page: this.currentPage,
          rows: this.pageSize,
          userDesc: this.queryUserDesc
        }
        axios.get(url, param).then(response => {
          this.tableData = response.data.data.list
          this.totalRows = response.data.data.total
          if (response) {
            this.loading = false
          } else {
            this.loading = true
          }
        });
      },

      getTableDataDept() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysUserDept/queryByUserId.do'
        var param = {
          userId: this.udp.user.id
        }
        axios.get(url, param).then(response => {
          this.tableDataDept = response.data.data
        });
      },

      getTableDataPost() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysUserPost/queryByUserId.do'
        var param = {
          userId: this.udp.user.id
        }
        axios.get(url, param).then(response => {
          this.tableDataPost = response.data.data
        });
      },
      handleAddDept() {
        this.$refs.popupDept.show()
      },
      handleAddPost() {
        this.$refs.popupPost.show()
      },
      receviceFromDept(dept) {
        this.userDept.dept = dept
        var url = 'framework/SysUserDept/save.do'
        var param = {
          json: JSON.stringify(this.userDept)
        }
        axios.post(url, param).then(response => {
          if (response.data.code === 0) {
            this.$message({
              type: 'success',
              message: '修改成功!',
            });
            //this.getTableDataUser()
            this.getTableDataDept()
          } else {
            this.$message({
              type: 'error',
              message: '修改失败' + response.data.msg,
            });
          }
        });

      },
      receviceFromPost(post) {
        this.userPost.post = post
        var url = 'framework/SysUserPost/save.do'
        var param = {
          json: JSON.stringify(this.userPost)
        }
        axios.post(url, param).then(response => {
          if (response.data.code === 0) {
            this.$message({
              type: 'success',
              message: '修改成功!',
            });
            //this.getTableDataUser()
            this.getTableDataPost()
          } else {
            this.$message({
              type: 'error',
              message: '修改失败' + response.data.msg,
            });
          }
        });
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val
        this.getTableData()
      },
      search() {
        this.getTableData()
      },
      getYesTableData() {
        var url = 'framework/SysUserDeptPostJSON/query.do'
        var param = {
          userId: this.udp.user.id
        }
        axios.get(url, param).then(response => {
          this.YesTableData = response.data
        });
      },
      handleAdd(val) {
        this.dialogVisible = true
        this.getDataTree()
        this.getDialogTableData()
      },
      getDialogTableData() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysPost/queryComboBox.do'
        var param = {}
        axios.get(url, param).then(response => {
          this.DialogTableData = response.data
          if (response) {
            this.loadingTree = false
          } else {
            this.loadingTree = true
          }
        });
      },
      getDataTree() {
        //console.log("获取table数据getDataTree")
        var url = 'framework/SysDepartment/queryTree.do?fid=0'
        var param = {}
        axios.get(url, param).then(response => {
          this.dataTree = response.data
          if (response) {
            this.loadingTree = false
          } else {
            this.loadingTree = true
          }
        });
      },
      handleCurrentRowChange(data) {
        this.udp.user.id = data.id
        this.userDept.user.id = data.id
        this.userPost.user.id = data.id
        this.getTableDataDept()
        this.getTableDataPost()
      },
      handleNodeClick(data) {
        this.udp.dept.id = data.id
        console.log("树结构" + this.udp.dept.id)
      },
      handleDialogChange(data) {
        this.udp.post.id = data.id
        console.log("表格" + this.udp.post.id)
      },
      handleSave(row) {
        var url = 'framework/SysUserDeptPostJSON/save.do'
        var addId = localStorage.getItem('userId');
        console.log('JSON.stringify(this.udp):' + JSON.stringify(this.udp))
        var param = {
          strJSON: JSON.stringify(this.udp),
          addId: addId,
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '修改成功!',
            });
            this.dialogVisible = false
            this.getTableData()
            this.getYesTableData()
          } else {
            this.$message({
              type: 'error',
              message: '修改失败' + response.data
            });
          }
        });
      },
      handleCancelSave(row) {
        this.dialogVisible = false
      },

      // 删除按钮事件
      handleDelete(id) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var userId = sessionStorage.getItem('userId');
          var url = 'framework/SysUserDeptPost/remove.do'
          var param = {
            id: id,
            userId: userId
          }
          axios.post(url, param).then(response => {
            if (response.data.code == '0') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableData()
              this.getYesTableData()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败' + response.data
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      handleDeletePost(row) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysUserPost/remove.do'
          var param = {
            id: row.id
          }
          axios.post(url, param).then(response => {
            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableDataPost()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败' + response.data.msg
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      handleDeleteDept(row) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysUserDept/remove.do'
          var param = {
            id: row.id
          }
          axios.post(url, param).then(response => {
            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableDataDept()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败' + response.data.msg
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },





    },



  }
</script>
<style>
  .udpJSON {
    margin: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/system/userdeptpostJSON.vue